import React, {useState, Fragment } from 'react';
import emailjs from 'emailjs-com';
import {FaFacebookSquare, FaInstagram,FaTwitter,FaMobileAlt,FaMapMarkedAlt} from 'react-icons/fa';
import {HiMail} from 'react-icons/hi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './css/contact.css';
// import Backimg from '../about/backimg';

const Contact = () => {
    const [data ,setData] = useState({
        name:'',
        number:'',
        email:'',
        message:''
    });


    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('harshitha', 'template_lsmqxqr', e.target, 'user_R5SH3EL0h2cwuKRJZO6al')
          .then((result) => {
              toast.success('We will contact you as soon as possible!');
              console.log(result.text);
          }, (error) => {
              toast.error(error.text)
              console.log(error.text);
          });
        e.target.reset();
        setData({
          name: '',
          email: '',
          number: '',
          company: '',
          message: '',
        })
      }
    
    const handleChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

    return (
        <Fragment>
        <ToastContainer />
            <div className='contact-header'></div>

            <div className='contact-block'>
                <div className='contact-details'>
                    <div>
                        <h2>let's meet</h2>
                        <div className='hidden-content'>
                            <div className='contact-info'>
                                <div><a href='tel:123456789' ><FaMobileAlt /> 123456789</a></div>
                                <div><a href='mailto:harshithadevelopers@gmail.com' ><HiMail /> harshithadevelopers@gmail.com</a></div>
                                <div><a href='https://goo.gl/maps/GSFAgXXyS5gxvidk7' ><FaMapMarkedAlt /> vijayawada, Andhra Pradesh.</a></div>
                            </div>
                            <div className='socialmedia_icons'>
                                <li><a href='https://www.facebook.com/'><i><FaFacebookSquare /></i> </a></li>
                                <li><a href='https://www.youtube.com/'><FaInstagram /></a></li>
                                <li><a href='https://www.youtube.com/'><FaTwitter /></a></li>
                                <li><a href='https://www.youtube.com/'><FaInstagram /></a></li>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='contact-form' >
                    <div>
                        <h2>get in touch</h2>
                        <p>feel free to contact us or send a message</p>
                        <form onSubmit={sendEmail}>
                            <div className='group'>
                                <input type='text'
                                 className='form-input' 
                                 placeholder='name' 
                                 name='name'
                                 value={data.name} 
                                 onChange={handleChange}
                                 required
                                 />
                            </div>
                            <div className='group'>
                                <input type='number'
                                 className='form-input'
                                  placeholder='number'
                                 name='number'
                                  value={data.number} 
                                  onChange={handleChange}
                                  required 
                                  />                        
                            </div>
                            <div className='group'>
                                <input type='email' 
                                className='form-input'
                                name='email'
                                 placeholder='email'
                                 value={data.email} 
                                 onChange={handleChange}
                                 required 
                                  />                            
                            </div>
                            <div className='group'>
                                <textarea 
                                 className='form-input'
                                  placeholder='info'
                                  name='message'
                                  value={data.message} 
                                  onChange={handleChange}
                                  required
                                   rows="6"
                                    cols="50" />                        
                            </div>

                            <input type='submit' value='submit' className='btn' />
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Contact;
